<template>
  <div class="app-container">

    <div class="box">

      <div class="filter-container">
        <el-input placeholder="用户名" v-model="pagination.username" style="width: 200px;" class="filter-item"></el-input>
        <el-input placeholder="手机号" v-model="pagination.phone" style="width: 200px;" class="filter-item"></el-input>
        <el-button @click="getuserlist()" class="dalfBut">查询</el-button>
        <el-button type="primary" class="butT" @click="handleCreate()">新建</el-button>
      </div>

      <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
        <el-table-column type="index" align="center" label="序号"></el-table-column>
        <el-table-column prop="username" label="用户名"  align="center"></el-table-column>
        <!--          <el-table-column prop="password" label="密码" align="center"></el-table-column>-->
        <!--          <el-table-column prop="salt" label="盐" align="center"></el-table-column>-->
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="deadline" label="过期时间" align="center"></el-table-column>
        <el-table-column prop="activeTime" label="激活时间" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="50px"></el-table-column>
        <el-table-column prop="activeFreq" label="剩余登录次数" align="center" ></el-table-column>
<!--        <el-table-column prop="status" label="状态" align="center"></el-table-column>-->
<!--        <el-table-column prop="isDeleted" label="注销" align="center"></el-table-column>-->
        <el-table-column prop="createTime" label="注册时间" align="center"></el-table-column>

<!--        <el-table-column label="更改激活次数" align="center" width="80px">-->

<!--          <template slot-scope="scope">-->

<!--            <el-button type="primary" size="mini" @click="handleUpdateactivetime(scope.row)">编辑</el-button>-->

<!--          </template>-->

<!--        </el-table-column>-->

        <el-table-column label="更改密码" align="center" width="80px">

          <template slot-scope="scope">

            <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>

          </template>

        </el-table-column>
        <el-table-column label="重置次数" align="center" width="80px">

          <template slot-scope="scope">

            <el-button type="primary" size="mini" @click="handleReset(scope.row)">重置</el-button>

          </template>

        </el-table-column>

        <el-table-column label="禁用启用" align="center" width="50px">

          <template slot-scope="scope">

            <el-switch
                v-model="scope.row.status"
                @change =handleopenorclose(scope.row)
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
                >
            </el-switch>

          </template>

        </el-table-column>

      </el-table>

      <!--分页组件-->
      <div class="pagination-container">

        <el-pagination
            class="pagiantion"

            @current-change="handleCurrentChange"

            :current-page="pagination.currentPage"

            :page-size="pagination.pageSize"

            layout="total, prev, pager, next, jumper"

            :total="pagination.total">

        </el-pagination>

      </div>

      <!-- 新增标签弹层 -->

      <div class="add-form">

        <el-dialog title="新增用户" :visible.sync="dialogFormVisible">

          <el-form ref="dataAddForm" :model="formData" :rules="rules" label-position="right" label-width="100px">

            <el-row>
              <el-col :span="24">
                <el-form-item label="用户名" prop="username">
                  <el-input v-model="formData.username"/>
                </el-form-item>
              </el-col>
            </el-row>


            <el-row>
              <el-col :span="24">
                <el-form-item label="密码" prop="password">
                  <el-input v-model="formData.password"/>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="确认密码" prop="password1">
                  <el-input v-model="password1"/>
                </el-form-item>
              </el-col>
            </el-row> <el-row>

            <el-col :span="24">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="formData.phone"/>
              </el-form-item>
            </el-col>
          </el-row>

          </el-form>

          <div slot="footer" class="dialog-footer">

            <el-button @click="cancel()">取消</el-button>

            <el-button type="primary" @click="handleAdd()">确定</el-button>

          </div>

        </el-dialog>

      </div>

      <!-- 更改密码弹层 -->

      <div class="add-form">

        <el-dialog title="修改密码" :visible.sync="dialogpasswordFormVisible4Edit">

          <el-form ref="dataEditForm" :model="updateform" :rules="rules1" label-position="right" label-width="100px" >

            <el-row>
              <el-col :span="15">
                <el-form-item label="新密码" prop="password">
                  <el-input v-model="updateform.password" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="15">
                <el-form-item label="确认密码" prop="password2">
                  <el-input v-model="password2"/>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>

          <div slot="footer" class="dialog-footer">

            <el-button @click="cancel()">取消</el-button>

            <el-button type="primary" @click="handleEdit()">确定</el-button>

          </div>

        </el-dialog>

      </div>


      <!-- 更改激活次数弹层 -->
      <div class="add-form">

        <el-dialog title="修改激活次数" :visible.sync="dialogactivetimeFormVisible4Edit">

          <el-form ref="dataEditForm" :model="updateform" label-position="right" label-width="100px">

            <el-row>
              <el-col :span="15">
                <el-form-item label="剩余激活次数" prop="activeTime">
                  <el-input v-model="updateform.activeTime" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>


          </el-form>

          <div slot="footer" class="dialog-footer">

            <el-button @click="cancel()">取消</el-button>

            <el-button type="primary" @click="handleactiveEdit()">确定</el-button>

          </div>

        </el-dialog>

      </div>

    </div>

  </div>


</template>

<script>
import axios from "@/axios";

export default {
  data() {
    return {
      dataList: [],//当前页要展示的列表数据
      dialogactivetimeFormVisible4Edit:false,//激活次数表单是否可见
      dialogpasswordFormVisible4Edit: false,//更改密码表单是否可见
      dialogFormVisible:false,//添加表单是否可见
      password1: "",
      formData: {
        username: "",
        password: "",
        phone: "",
        salt: ""
      },//表单数据
      rules: {//校验规则
        username: [{ required: true, message: '用户名为必填项', trigger: 'blur' }],
        password: [{ required: true, message: '密码为必填项', trigger: 'blur' }],
        phone: [{ required: true, message: '手机号为必填项', trigger: 'blur' }]
      },
      pagination: {//分页相关模型数据
        currentPage: 1,//当前页码
        pageSize:10,//每页显示的记录数
        total:0,//总记录数
        username:"",
        phone:""
      },
      updateform: {
        activeTime: "",
        createTime: "",
        deadline: "",
        id: 1,
        isDeleted: 0,
        password: "",
        phone: "",
        salt: "",
        status: true,
        type: 0,
        activeFreq: 5,
        updateTime: "",
        username: ""
      },
      rules1:{
        password: [
          { required: true, message: '请输入密码', transform: value => value, trigger: 'blur' },
          {
            type: 'string',
            message: '请输入不包含空格的字符',
            trigger: 'blur',
            transform(value) {
              if (value && value.indexOf(' ') === -1) {
                return value
              } else {
                return false
              }
            }
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$).{8,16}/
              if (!passwordreg.test(value)) {
                callback(new Error('密码必须由数字、字母、特殊字符组合,请输入8-16位'))
              }else{
                callback()
              }
            } }
        ],
      },
      password2:""
    }
  },
  created() {
    this.password1 = ""
    this.password2 = ""
    this.getuserlist()

  },

  methods: {

          // selectbyusername(){
          //   axios({
          //     method:"post",
          //     url:"/app/user/list",
          //     data: this.selectbyusername
          //   }).then(res=>{
          //     this.pagination.pageSize = res.data.data[0].size;
          //     this.pagination.currentPage = res.data.data[0].current;
          //     this.pagination.total = res.data.data[0].total;
          //     this.dataList = res.data.data[0].records
          //     console.log("----------------------------------------------")
          //     console.log(res.data.data[0].records)
          //   })
          // },

          getuserlist(){
            axios({
              method:"post",
              url:"/app/user/page",
              data:{
                page: this.pagination.currentPage,
                limit: this.pagination.pageSize,
                username: this.pagination.username,
                phone: this.pagination.phone
              }
            }).then(res=>{
              this.pagination.pageSize = res.data.data.size;
              this.pagination.currentPage = res.data.data.current;
              this.pagination.total = res.data.data.total;
              this.dataList = res.data.data.records
              for (let i = 0; i < this.dataList.length; i++) {
                console.log(this.dataList[i].username);
                this.dataList[i].username = decodeURI(this.dataList[i].username,"utf-8");
                console.log(this.dataList[i].username);
              }
               //console.log(this.dataList.username.length);
            })
          },
          //切换页码
          handleCurrentChange(currentPage) {
            //修改页码值为当前选中的页码值
            this.pagination.currentPage = currentPage;
            //执行查询
            this.getuserlist();
          },

          //弹出添加窗口
          handleCreate() {
            this.dialogFormVisible = true;
            this.resetForm();
          },

          //重置表单
          resetForm() {
            this.formData = {};
          },

          //添加
          handleAdd () {


            if(this.password1 !== (this.formData.password)){
              this.$message.error("两次密码不同请重新输入");
            }else {
              this.saltutils();
              axios.post("/app/user/register", this.formData).then((res) => {
                //判断当前操作是否成功

                this.dialogFormVisible = false;
                this.$message.success(res.data.msg);
                this.password1 = '';
              }).finally(() => {
                //2.重新加载数据
                this.getuserlist();
              });
            }
          },

          //取消
          cancel(){
            this.dialogpasswordFormVisible4Edit = false;
            this.dialogactivetimeFormVisible4Edit = false;
            this.dialogFormVisible = false;
            this.password1 = ""
            this.password2 = ""
            this.$message.info("当前操作取消");
          },

          // // 删除
          // handleDelete(row) {
          //   // console.log(row);
          //   this.$confirm("此操作永久删除当前信息，是否继续？","提示",{type:"info"}).then(()=>{
          //     axios.delete("/app/user/delete/"+row.id).then((res)=>{
          //         this.$message.success("删除成功");
          //     }).finally(()=>{
          //       //2.重新加载数据
          //       this.getuserlist();
          //     });
          //   }).catch(()=>{
          //     this.$message.info("取消操作");
          //   });
          // },

          //弹出编辑窗口
          handleUpdate(row) {
            this.updateform = row;
            this.dialogpasswordFormVisible4Edit = true;
            this.password2 = ""
            this.updateform.password = ""
          },

          handleUpdateactivetime(row) {
            this.updateform = row;
            this.dialogactivetimeFormVisible4Edit = true;
          },

          //修改
          handleEdit() {
            if(this.password2 !== (this.updateform.password)){
              this.$message.error("两次密码不同请重新输入");
            }else {
              axios.put("/app/user/update",this.updateform).then((res)=>{
                //判断当前操作是否成功
                this.dialogpasswordFormVisible4Edit = false;
                this.$message.success("修改成功");
              }).finally(()=>{
                //2.重新加载数据
                this.getuserlist();
                this.password2 = ""
              });
            }
          },
          handleReset(row) {
              this.updateform = row;
              this.updateform.activeFreq = 5;
              axios.put("/app/user/update",this.updateform).then((res)=>{
                //判断当前操作是否成功
                this.$message.success("重置成功");
              }).finally(()=>{
                //2.重新加载数据
                this.getuserlist();
              });
          },
          handleactiveEdit() {

              axios.put("/app/user/update",this.updateform).then((res)=>{
                //判断当前操作是否成功
                this.dialogactivetimeFormVisible4Edit = false;
                this.$message.success("修改成功");
              }).finally(()=>{
                //2.重新加载数据
                this.getuserlist();
              });
          },

    //禁用启用用户
          handleopenorclose(row){
            console.log(row)
            this.updateform = row;
            if(row.status === true) {
              this.updateform.status = 1
            }
            axios.put("/app/user/update",this.updateform).then((res)=>{
              this.$message.success("修改成功");
            }).finally(()=>{
              //2.重新加载数据
              this.getuserlist();
            });
          },

          saltutils(){
            var data=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"];
            var result="";
            for(var i=0;i<20;i++){
              var r=Math.floor(Math.random()*62);		//取得0-62间的随机数，目的是以此当下标取数组data里的值！
              result+=data[r];		//输出20次随机数的同时，让rrr加20次，就是20位的随机字符串了。
            }
            this.formData.salt = result
          }
        },
          changetrueand1(){
            if (this.dataList.status === 1){
              this.dataList.static = true
            }else{
              this.dataList.static = false
            }
          }






}
</script>

<style scoped>

.app-container{

  background: #fff;

  margin: 15px 30px 15px 15px;

}

.box {

  position: relative;

  border-radius: 3px;

  background: #ffffff;

  border-top: 3px solid #3c8dbc;

  padding: 10px;

  margin-bottom: 20px;

  width: 100%;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

}

.filter-container{

  float: left;
  padding:10px 0 15px 0;


}
.pagiantion{

  text-align: right;

  padding: 15px;

}

</style>
